import { Box } from '@mui/material'
import { whiteColor } from 'configs/styles/muiThemes'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import TwitterIcon from '@mui/icons-material/Twitter'

function SocialShare({ url, quote, back, iconSize }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
      }}
    >
      <WhatsappShareButton url={url} quote={quote} hashtag='' onClick={back}>
        <Box
          sx={{
            ...styles.iconBtn,
            backgroundColor: '#42be50',
          }}
        >
          <WhatsAppIcon sx={{fontSize: iconSize || '24px'}} />
        </Box>
      </WhatsappShareButton>

      <FacebookShareButton url={url} quote={quote} hashtag='' onClick={back}>
        <Box
          sx={{
            ...styles.iconBtn,
            backgroundColor: '#1977F3',
          }}
        >
          <FacebookOutlinedIcon sx={{fontSize: iconSize || '24px'}} />
        </Box>
      </FacebookShareButton>

      <LinkedinShareButton url={url} quote={quote} hashtag='' onClick={back}>
        <Box
          sx={{
            ...styles.iconBtn,
            backgroundColor: '#0077B5',
          }}
        >
          <LinkedInIcon sx={{fontSize: iconSize || '24px'}} />
        </Box>
      </LinkedinShareButton>

      <TwitterShareButton url={url} quote={quote} hashtag='' onClick={back}>
        <Box
          sx={{
            ...styles.iconBtn,
            backgroundColor: '#1DA1F2',
          }}
        >
          <TwitterIcon sx={{fontSize: iconSize || '24px'}} />
        </Box>
      </TwitterShareButton>
    </Box>
  )
}

export default SocialShare

const styles = {
  iconBtn: {
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '11px',
    color: whiteColor,
    borderRadius: '7px',
  },
}
